import { useState, useEffect } from 'react';

const UseDarkMode = () => {
    // Initialize state from localStorage or default to false (light mode)
    const [isDarkMode, setIsDarkMode] = useState(() => {
        try {
            const storedTheme = window.localStorage.getItem('darkMode');
            return storedTheme === 'true';
        } catch (error) {
            console.error("Error reading from localStorage:", error);
            return false;
        }
    });

    // Effect to update localStorage and the document body class
    useEffect(() => {
        try {
            console.log("[UseDarkMode] state : ", isDarkMode);
            window.localStorage.setItem('darkMode', isDarkMode);
            if (isDarkMode) {
                document.body.parentElement.classList.add('dark');
            } else {
                document.body.parentElement.classList.remove('dark');
            }
        } catch (error) {
            console.error("Error writing to localStorage or manipulating DOM:", error);
        }
    }, [isDarkMode]);

    // Function to toggle dark mode
    const toggleDarkMode = () => {
        setIsDarkMode(prevMode => !prevMode);
    };

    return [isDarkMode, toggleDarkMode];
};

export default UseDarkMode;